module.exports = __webpack_public_path__ + "static/media/galleryImg1.d8cf6fd8.jpg";